import React from "react";

type MediaBoolean = "isTablet" | "isMobile" | "isDesktop" | "isSmallDesktop";

type MediaQuery = { key: MediaBoolean; query: string };

export type MediaMap = Record<MediaBoolean, boolean>;

const QUERIES: MediaQuery[] = [
  { key: "isMobile", query: "screen and (max-width: 800px)" },
  { key: "isTablet", query: "screen and (max-width: 1250px)" },
  { key: "isSmallDesktop", query: "screen and (max-width: 1450px)" },
  { key: "isDesktop", query: "screen and (min-width: 1451px)" },
];

const mediaQueryLists = QUERIES.map((q) => ({
  key: q.key,
  mediaQueryList: window.matchMedia(q.query),
}));

export default function useMediaQuery() {
  const updateMediaQueryMatch = (mq: any) => (state: any) => ({
    ...state,
    [mq.key]: mq.mediaQueryList.matches,
  });

  const [values, setValues] = React.useState(() =>
    mediaQueryLists.reduce((acc, mq) => updateMediaQueryMatch(mq)(acc), {})
  );

  React.useEffect(() => {
    const listeners = mediaQueryLists.map((mq) => {
      const handler = () => setValues(updateMediaQueryMatch(mq));
      mq.mediaQueryList.addListener(handler);
      return {
        handler,
        mq,
      };
    });

    return () =>
      listeners.forEach((listener) =>
        listener.mq.mediaQueryList.removeListener(listener.handler)
      );
  }, []);

  return values as MediaMap;
}
